import {useMemo} from 'react';
import {useSelectedNodes} from '../state/networkEditStore';
import {useNetworkLinks} from '../state/networkHooks';
import {NodeId} from '../state/networkStore';

function checkIsValid<T>(positionInCheck: T, initialPosition: T, arrayedLinks: T[][]) {
    const isLinkInvalid = arrayedLinks
        .filter(link => link[0] === initialPosition || link[1] === initialPosition)
        .flatMap(link => link)
        .includes(positionInCheck);

    // console.log(isLinkInvalid ? 'Link INVALID for' : 'Link Valid for', positionInCheck, 'against', initialPosition, 'with links', arrayedLinks);
    return !isLinkInvalid;
}

export const useIsLinkValid = (nodeId: NodeId) => {
    const selectedNodes = useSelectedNodes();
    const links = useNetworkLinks();

    return useMemo(() => {
        if (selectedNodes.length === 0) return true;
        if (selectedNodes.includes(nodeId)) return false;
        const arrayedLinks: NodeId[][] = links.map(l => [l.nodeIdA, l.nodeIdB]);
        return checkIsValid<NodeId>(nodeId, selectedNodes[0], arrayedLinks);
    }, [selectedNodes, links, nodeId]);
};
